<template>
  <div id="auditoperation">
    <!-- 审核操作 -->
    <diy_infomation
      v-loading="loading"
      v-if="infomationData.flag"
      :infomationData="infomationData"
      @changeSH="changeSH"
      content_top
      @ButtonClick="ButtonClick"
      @btnClick="btnClick"
    ></diy_infomation>
    <div class="content" v-if="showinfo">
      <div class="">
        <div class="search">
          <diy_search
            :searchData="searchList"
            @initTableData="initTableData"
          ></diy_search>
        </div>
        <!-- <div class="search_left"></div> -->
      </div>
      <div class="content_content">
        <div class="tableData">
          <el-table
            ref="singleTable"
            :data="tableData"
            highlight-current-row
            style="width: 100%"
            height="100%"
            :header-cell-style="{
              background: ' rgba(240, 240, 240, 1)',
              color: '#000000',
            }"
            :default-sort="sortConfig"
            @sort-change="sortChange"
          >
            <!-- <el-table-column width="55" type="selection" fixed>
            </el-table-column> -->
            <template
              ><el-table-column
                v-for="(item, index) in tableMenu"
                :property="item.key"
                :key="index"
                :label="item.name"
                :show-overflow-tooltip="item.key != 'isSelect'"
                :width="item.width"
                :sortable="item.sortable"
                style="background-color: #eee"
              >
              </el-table-column>
            </template>
            <el-table-column label="操作" width="80" fixed="right">
              <template slot-scope="scope">
                <el-button
                  @click="handleClick(scope.row, 'audit', scope)"
                  type="text"
                  size="small"
                  >审核</el-button
                >
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="pageSize">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="pageData.currentPage"
            :page-size="pageData.pageSize"
            layout="total,sizes, prev, pager, next,jumper"
            :total="pageData.total"
          >
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as auditoperationData from "./auditoperation.js";
export default {
  data() {
    return {
      loading: false,
      showinfo: true,
      configList: {
        // 所有配置项数组集
        schoolList: [], //学校
        professionList: [], // 专业
      },
      searchList: [],
      pageData: {
        // 分页参数
        currentPage: 1, // 当前页数
        total: 0, // 总条目数
        pageSize: 20, // 每页条数
      },
      sortConfig: {
        prop: "apply_time",
        order: "descending",
      },
      tableMenu: auditoperationData.getAttributeMenu(),
      tableData: [],
      infomationData: {
        flag: false,
        // activebtn: 0,
        blist: [
          {
            name: "返回列表",
            active: "auditOperation",
            icon: "el-icon-d-arrow-left",
          },
        ],
        data: auditoperationData.getpeopleinfo(),
        buttonArray: [
          // { name: "短信发送通知", active: "infoSend", isNull: false },
          // { name: "保存", active: "save", isNull: false },
          { name: "完成", active: "makesure", isNull: false },
        ],
      },
      multipleSelection: [],
      tempTableItem: {},
    };
  },
  methods: {
    //查看审核不通过原因
    getLabelList() {
      this.$request(
        "post",
        "/label/getLabelList",
        { type: "refuseReason" },
        (data) => {
          console.log("//查看审核不通过原因", data);
          let arr = [];
          for (let index = 0; index < data.length; index++) {
            const element = data[index];
            let obj = {
              label: element.content,
              value: element.content,
            };
            arr.push(obj);
          }
          this.infomationData.data.forEach((element) => {
            if (element.key == "refuseReason") {
              element.options = arr;
            }
          });
          this.getLabelList2();
        }
      );
    },
    /**
     * 获取报考专业
     */
    getLabelList2() {
      let requestData = {
        type: "profession",
      };
      this.configList.professionList = [];
      this.$request("post", "/label/getLabelList", requestData, (data) => {
        data.forEach((element) => {
          let dd = {
            label: element.content,
            value: element.content,
          };
          this.configList.professionList.push(dd);
        });
        this.getAllSchool();
      });
    },
    //获取学校列表
    getAllSchool() {
      // this.searchList = auditoperationData.getSearchData(this.configList);
      this.$request("post", "/enrollInfo/getAllSchool", null, (data) => {
        console.log("获取学校列表", data);
        let arr = [];
        for (let index = 0; index < data.length; index++) {
          const element = data[index];
          let obj = {
            label: element,
            value: element,
          };
          arr.push(obj);
        }
        this.configList.schoolList = arr;
        this.searchList = auditoperationData.getSearchData(this.configList);
        this.initTableData();
      });
    },

    initTableData() {
      let requestData = {
        search: this.searchList[0].value,
        school: this.searchList[1].value,
        readyProfession: this.searchList[2].value,
        specialFlag: this.searchList[3].value,
        sortProp: this.sortConfig.prop, //排序字段
        sortOrder: this.sortConfig.order, //排序方式
        pageSize: this.pageData.pageSize,
        currentPage: this.pageData.currentPage,
      };
      this.$request("post", "/enrollInfo/getCheckList", requestData, (data) => {
        this.tableData = data.tableData;
        this.pageData.total = data.total;
      });
    },

    //返回实时数据
    ButtonClick(active, item) {
      switch (active) {
        case "auditOperation":
          console.log("返回审核操作");
          this.showinfo = true;
          this.infomationData.flag = false;
          break;

        default:
          break;
      }
    },
    btnClick(active, item) {
      let requestData = {};
      switch (active) {
        //审核确定
        case "makesure":
          requestData = {};
          console.log(this.infomationData.data);
          this.infomationData.data.forEach((element) => {
            if (element.key == "status") {
              requestData.status = element.value;
            }
            if (element.key == "refuseReason") {
              requestData.refuseReason = element.value;
            }
          });
          if (requestData.status == "") {
            this.$message({
              type: "warning",
              message: "审核结果不可为空!",
            });
            return;
          }
          if (
            (requestData.status == "2" || requestData.status == 2) &&
            requestData.refuseReason != ""
          ) {
            this.$message({
              type: "warning",
              message: "审核通过时,不可选择不通过原因",
            });
            return;
          }
          if (
            (requestData.status == "3" || requestData.status == 3) &&
            requestData.refuseReason == ""
          ) {
            this.$message({
              type: "warning",
              message: "不通过原因不可为空!",
            });
            return;
          }
          //选择通过
          requestData.id = this.tempTableItem.id;
          // requestData.refuseReason = "";
          requestData.checkUser = sessionStorage.getItem("operatorID");
          this.$confirm("审核操作, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              this.$request(
                "post",
                "/enrollInfo/checkInfo",
                requestData,
                (data) => {
                  // this.$confirm(
                  //   "是否立即短信通知 " +
                  //     this.infomationData.data[0].value +
                  //     " 考生?",
                  //   "提示",
                  //   {
                  //     confirmButtonText: "立即通知",
                  //     cancelButtonText: "稍后通知",
                  //     type: "warning",
                  //   }
                  // )
                  //   .then(() => {
                  //     this.$request(
                  //       "post",
                  //       "/enrollInfo/sendNotice",
                  //       [this.tempTableItem.id],
                  //       (data) => {
                  //         this.$message({
                  //           type: "success",
                  //           message: "短信已发送!",
                  //           duration: 1000,
                  //         });
                  //         this.showinfo = true;
                  //         this.infomationData.flag = false;
                  //         this.initTableData();
                  //       }
                  //     );
                  //   })
                  //   .catch(() => {
                  //     this.$message({
                  //       type: "info",
                  //       message: "审核成功!",
                  //       duration: 1000,
                  //     });
                  //     this.showinfo = true;
                  //     this.infomationData.flag = false;
                  //     this.initTableData();
                  //   });
                  this.showinfo = true;
                  this.infomationData.flag = false;
                  this.initTableData();
                }
              );
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: "已取消操作",
              });
            });
          break;

        default:
          break;
      }
    },
    changeSH(value) {
      console.log("审核结果", value);
      if (value == "2" || value == 2) {
        this.infomationData.data.forEach((element) => {
          if (element.key == "refuseReason") {
            element.value = "";
          }
        });
      }
    },
    //表格操作事件
    handleClick(item, active, scope) {
      let requestData = {};
      switch (active) {
        //审核s
        case "audit":
          this.loading = true;
          console.log("shenhgheheh", scope);
          requestData = {};
          this.tempTableItem = scope.row; //将选中的当行数据存储在里面
          requestData.enrollId = scope.row.id;
          requestData.flag = sessionStorage.getItem("flag");
          let icons = ["png", "jpeg", "jpg"];
          this.infomationData.data = auditoperationData.getpeopleinfo();
          this.$request(
            "post",
            "/enrollInfo/getEnroll",
            requestData,
            (data) => {
              console.log("查询个人报名资料", data);
              this.showinfo = false;
              this.infomationData.flag = true;
              this.infomationData.data.forEach((element) => {
                if (
                  element.key != "status" &&
                  element.key != "" &&
                  element.key != "refuseReason"
                ) {
                  if (
                    element.key == "statusCheckFile" &&
                    (data.graduating == "2" || data.graduating == 2)
                  ) {
                    element.value = data.diplomaFile;
                    element.key = "diplomaFile";
                    element.name = "中职毕业证原件";
                  } else {
                    element.value = data[element.key];
                  }
                }
                if (element.key == "graduating") {
                  element.value =
                    data[element.key] == "1" ? "应届生" : "往届生";
                }
                if (element.type == "file" && data[element.key].length > 0) {
                  console.log(data[element.key]);
                  let ii = data[element.key][0].path.split(".");
                  // 文件若为图片,以缩略图展示
                  console.log("文件后缀", ii[ii.length - 1]);
                  if (ii.length > 0 && icons.includes(ii[ii.length - 1])) {
                    element.type = "icon";
                  } else {
                    element.type = "file";
                  }
                }
                if (
                  element.type == "fileOrIcon" &&
                  data[element.key].length > 0
                ) {
                  // 文件或图片展示
                  data[element.key].forEach((file) => {
                    let ii = file.path.split(".");
                    if (ii.length > 0 && icons.includes(ii[ii.length - 1])) {
                      // 如果这一个附件为图片,给这条附件添加icon属性
                      this.$set(file, "flag", "icon");
                    } else {
                      // 否则为文件,添加file属性
                      this.$set(file, "flag", "file");
                    }
                  });
                }
              });
              this.loading = false;
            }
          );

          break;
        default:
          break;
      }
    },

    /**
     * 页码选择器改变事件
     * val:每页条数
     */
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageData.pageSize = val;
      this.initTableData();
    },
    /**
     * 选择页码事件
     * val:当前页
     */
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.initTableData();
    },
    sortChange(e) {
      console.log("排序规则:", e);
      this.sortConfig.sortProp = e.prop;
      this.sortConfig.sortOrder = e.order;
    },
  },

  //
  mounted() {
    this.getLabelList(); //查看审核不通过原因
  },
};
</script>

<style lang="less" scoped>
#auditoperation {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .content {
    width: 100%;
    height: 100%;
    border-radius: 10px;
    background: rgba(255, 255, 255, 1);
    box-sizing: border-box;
    padding: 5px 32px;
    display: flex;
    flex-direction: column;
    .content_top {
      width: 100%;
      height: 40px;
      display: flex;
      box-sizing: border-box;
      margin-bottom: 10px;
      .search {
        height: 100%;
        // width: 50%;
      }
      .search_left {
        height: 100%;
        width: 50%;
        display: flex;
        // justify-content: space-around;
        align-items: center;
        .btn {
          // width: 78px;
          height: 40px;
          box-sizing: border-box;
          border-radius: 3px;
          background: rgba(0, 118, 252, 1);
          padding: 10px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          &:hover {
            cursor: pointer;
            scale: (90%);
          }
          > img {
            width: 16px;
            height: 16px;
          }
          > span {
            margin-left: 5px;
            font-size: 14px;
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
        }
      }
    }
    .content_content {
      width: 100%;
      height: 0;
      flex: 1;
      > .tableData {
        width: 100%;
        height: 0;
        flex: 1;
        height: 90%;

        .dir {
          display: flex;
          > .dit {
            width: auto;
            height: auto;
            padding: 2px 8px;
            margin: 0 4px;
            box-sizing: border-box;
            background-color: #00a0fc23;
            font-size: 13px;
            border-radius: 4px;
            &:nth-child(1) {
              margin-left: 0;
            }
          }
        }
        .dut {
          font-size: 13px;
          color: #31b3ffe7;
          transition: 0.3s;
          &:hover {
            cursor: pointer;
            text-decoration: underline;
            text-underline-offset: 5px;
          }
        }
      }
    }
  }
}
</style>
